export const domainDetails = {
  chargemiles: {
    palette: {
      primary: {
        lighter: "#C8FACD",
        light: "#5BE584",
        main: "#00AB55",
        dark: "#007B55",
        darker: "#005249",
        contrastText: "#fff",
      },
    },
    email:"support@chargemiles.ca",
    name: "ChargeMiles",
    logoUrl: "logo/chargemiles.jpeg",
    faviconUrl: "chargemilesFavicon.ico",
    title: "ChargeMiles-CMS",
    mapUrl: "https://map.chargemiles.ca",
    domain:"chargemiles",
    filterColor:
      "invert(20%) sepia(100%) saturate(5000%) hue-rotate(100deg) brightness(95%) contrast(105%);",
  },
  moveonev: {
    domain:"moveonev",
    palette: {
      primary: {
        lighter: "#C8FACD",
        light: "#5BE584",
        main: "#dc3545",
        dark: "#A60020",
        darker: "#005249",
        contrastText: "#fff",
      },
    },
    email:"info@moveonev.com",
    name: "MoveonEV",
    logoUrl: "logo/moveon.png",
    title: "MoveonEV-CMS",
    mapUrl: "https://map.moveonev.com",
    faviconUrl: "moveonevfavicon.ico",
    filterColor:
      "invert(25%) sepia(89%) saturate(3548%) hue-rotate(341deg) brightness(94%) contrast(82%);",
  },
  amikcharge: {
    domain:"amiktechnologies",
    isAmik: true,
    palette: {
      // Amik Design System signature blue (#1488D6 — gradient start)
      primary: {
        lighter: "#E3F1FB",
        light: "#5BB0E6",
        main: "#1488D6",
        dark: "#0F6FB0",
        darker: "#0B5689",
        contrastText: "#fff",
      },
    },
    email:"info@amiktech.in",
    name: "Amik",
    logoUrl: "logo/amikBrand.svg",
    title: "AmikCharge-CMS",
    mapUrl: "https://map.amiktechnologies.com",
    faviconUrl: "static/amikUpdateIcon.svg",
    filterColor:
      "brightness(0) saturate(100%) invert(43%) sepia(86%) saturate(1357%) hue-rotate(178deg) brightness(91%) contrast(91%)",
  },
  amiktechnologies: {
    domain:"amiktechnologies",
    isAmik: true,
    palette: {
      // Amik Design System signature blue (#1488D6 — gradient start)
      primary: {
        lighter: "#E3F1FB",
        light: "#5BB0E6",
        main: "#1488D6",
        dark: "#0F6FB0",
        darker: "#0B5689",
        contrastText: "#fff",
      },
    },
    email:"info@amiktech.in",
    name: "Amik",
    logoUrl: "logo/amikBrand.svg",
    title: "AMIKTechnologies-CMS",
    mapUrl: "https://map.amiktechnologies.com",
    faviconUrl: "static/amikUpdateIcon.svg",
    filterColor:
      "brightness(0) saturate(100%) invert(43%) sepia(86%) saturate(1357%) hue-rotate(178deg) brightness(91%) contrast(91%)",
  },
  techvoltnetwork: {
    domain:"techvoltnetwork",
    palette: {
      primary: {
        lighter: "#52D28E",
        light: "#2FB873",
        main: "#149631",
        dark: "#0F6E24",
        darker: "#0A4B18",
        contrastText: "#fff"
      },      
    },
    email:"techvoltnetwork@gmail.com",
    name: "Techvolt",
    logoUrl: "logo/techvoltNetwork.jpg",
    title: "Techvolt-CMS",
    mapUrl: "https://map.techvoltnetwork.com",
    faviconUrl: "static/techvoltNetworkFavicon.ico",
    filterColor:
      "invert(20%) sepia(100%) saturate(5000%) hue-rotate(100deg) brightness(95%) contrast(105%);",
  },
  acsenergy: {
    domain:"acsenergy",
    palette: {
      primary: {
        lighter: "#C8FACD",
        light: "#5BE584",
        main: "#007fff",
        dark: "#003366",
        darker: "#005249",
        contrastText: "#fff",
      },
    },
    email:"support@acsenergy.in",
    name: "ACS Energy",
    logoUrl: "https://avvmediabucket.blob.core.windows.net/avv-media/networkFilters/ACSEnergyLogo_BlackFont.png",
    title: "ACSEnergy-CMS",
    mapUrl: "https://map.acsenergy.in",
    faviconUrl: "static/acsFavicon.ico",
    filterColor:
      " brightness(0) saturate(100%) invert(33%) sepia(31%) saturate(4652%) hue-rotate(197deg) brightness(101%) contrast(110%)",
  },
  avvtech: {
    domain:"avvtech",
    palette: {
      primary: {
        lighter: "#B3E5FC",
        light: "#4FC3F7",
        main: "#03A9F4",
        dark: "#0288D1",
        darker: "#01579B",
        contrastText: "#fff",
      },
    },
    email:"info@avvtech.ca",
    name: "AvvTech",
    logoUrl: "https://static.joonsite.com/storage/4854/media/2411300853545403.png",
    title: "AvvTech-CMS",
    mapUrl: "https://map.avvtech.ca",
    faviconUrl: "static/amikUpdateIcon.svg",
    filterColor:
      "brightness(0) saturate(100%) invert(46%) sepia(85%) saturate(1471%) hue-rotate(192deg) brightness(101%) contrast(102%)",
  },
  zerofootprint: {
    domain:"zerofootprint",
    palette: {
      primary: {
        lighter: "#52D28E",
        light: "#2FB873",
        main: "#149631",
        dark: "#0F6E24",
        darker: "#0A4B18",
        contrastText: "#fff"
      },      
    },
    email:"support@zerofootprint.in",
    name: "ZeroFootprint",
    logoUrl: "logo/zerofootprint.png",
    title: "ZeroFootprint-CMS",
    mapUrl: "https://map.zerofootprint.in",
    faviconUrl: "static/zerofootprintFavicon.ico",
    filterColor:
      "invert(20%) sepia(100%) saturate(5000%) hue-rotate(100deg) brightness(95%) contrast(105%);",
  },
  bharatnp: {
    domain: "bharatnp",
    palette: {
      primary: {
        lighter: "#E8F5D6",
        light: "#8CC63F",
        main: "#5E9E2E",
        dark: "#477A22",
        darker: "#2F5416",
        contrastText: "#fff",
      },
      secondary: {
        lighter: "#FDECD1",
        light: "#FBB040",
        main: "#F7941E",
        dark: "#C56F0C",
        darker: "#8A4B06",
        contrastText: "#fff",
      },
    },
    email: "Supgbt@gmail.com",
    name: "GBT EV Recharge",
    logoUrl: "https://avvmediabucket.blob.core.windows.net/avv-media/networkFilters/bharatnp.png",
    title: "GBT-CMS",
    mapUrl: "https://map.bharatnp.com",
    faviconUrl: "static/bharatnp.ico",
    filterColor:
      "invert(56%) sepia(58%) saturate(548%) hue-rotate(38deg) brightness(94%) contrast(88%);",
  },
};
